import React from "react";
import { Baby, BookOpen, CheckCircle2, ClipboardList, HeartPulse, Target, TrendingUp, Zap } from "lucide-react";
import { CollapsibleItem } from "./CollapsibleItem";
import { everyTomeIncludes, tomes } from "../data/content";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
const tomeIcons = [BookOpen, Zap, HeartPulse, TrendingUp, Target, ClipboardList, Baby];
export function TomesSection() {
  return <Reveal className="bg-[#080B14] px-5 py-24 sm:px-8 lg:px-12" data-id="element-257" data-mp="3lhjqfrvpfgyp">
      <div className="mx-auto max-w-[900px]" data-id="element-258" data-mp="3qiz6t6mxszar">
        <SectionHeading title="Los 7 Tomos" subtitle="Para profes de atletismo de todos los niveles y enfoques" data-id="element-259" data-mp="3qfl7665nr470" />

        <div className="space-y-3" data-id="element-260" data-mp="3gji510at35k2">
          {tomes.map((tome, index) => {
          const Icon = tomeIcons[index];
          const bullets = tome.details ?? everyTomeIncludes.slice(0, 4);
          return <CollapsibleItem key={tome.number} header={<div className="flex min-w-0 flex-1 items-center gap-4" data-id="element-262" data-mp="wcqjbp42nb0j">
                    <div className="flex size-14 shrink-0 items-center justify-center rounded-xl border border-[#F5B83D]/15 bg-[#050B16]" data-id="element-263" data-mp="re5lfwcal3f9">
                      <Icon className="size-6 text-[#F5B83D]" aria-hidden="true" data-id="element-264" data-mp="1620fbg21ddtx" />
                    </div>
                    <div className="min-w-0 flex-1" data-id="element-265" data-mp="1159z8sq8ei8i">
                      <div className="flex flex-wrap items-center gap-2" data-id="element-266" data-mp="dee87xtlnr2b">
                        <span className="text-sm font-black uppercase tracking-wide text-[#E3262E]" data-id="element-267" data-mp="dgh0koi85wa7">Tomo {tome.number}</span>
                        <span className="rounded-md border border-[#F5B83D]/25 bg-[#2A2410] px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-[#F5B83D]" data-id="element-268" data-mp="ncakisy9ws20">
                          {tome.eyebrow}
                        </span>
                      </div>
                      <h3 className="mt-2 text-lg font-black leading-snug text-white sm:text-xl" style={{
                fontSize: "13px"
              }} data-id="element-269" data-mp="1ypwb8ijs71pn">{tome.title}</h3>
                      <p className="mt-1 text-sm leading-5 text-[#AAB7C8]" style={{
                fontSize: "13px"
              }} data-id="element-270" data-mp="20wcb8dbnya9f">{tome.description}</p>
                    </div>
                  </div>} data-id="element-261" data-mp="1esojzxi1tw4o" data-mpi={index}>
                <div className="flex gap-4 px-5 pb-6 sm:px-6" data-id="element-271" data-mp="2atqs2e1i1129">
                  <div className="w-14 shrink-0" aria-hidden="true" data-id="element-272" data-mp="2as5yaqn0dm5g" />
                  <div className="min-w-0 flex-1 space-y-2 border-t border-white/10 pt-4" data-id="element-273" data-mp="2fslavfzgupmd">
                    {bullets.map(detail => <div key={detail} className="flex gap-2 text-sm leading-5 text-[#C7CED8]" data-id="element-274" data-mp="1n4fq4t8ex0mj">
                        <CheckCircle2 className="mt-0.5 size-4 shrink-0 text-[#27B36A]" aria-hidden="true" data-id="element-275" data-mp="1s3iusckhd4tz" />
                        {detail}
                      </div>)}
                  </div>
                </div>
              </CollapsibleItem>;
        })}
        </div>

        <div className="mt-12 rounded-2xl border border-[#F5B83D]/25 bg-[#0D1424] p-6 sm:p-9" data-id="element-276" data-mp="14dohjtw91e97">
          <h3 className="text-center text-2xl font-black text-white" data-id="element-277" data-mp="3hny0h13plv98">Cada tomo incluye</h3>
          <div className="mt-7 grid gap-3 md:grid-cols-2" data-id="element-278" data-mp="3dmmj1iuzogc4">
            {everyTomeIncludes.map(item => <div key={item} className="flex gap-3 rounded-lg bg-white/[0.035] p-4 text-sm leading-6 text-[#C7CED8]" style={{
            fontSize: "11px"
          }} data-id="element-279" data-mp="38n9kw1yo3mu8">
                <CheckCircle2 className="mt-0.5 size-5 shrink-0 text-[#27B36A]" aria-hidden="true" data-id="element-280" data-mp="33nwz7kjj8lt8" />
                {item}
              </div>)}
          </div>
        </div>
      </div>
    </Reveal>;
}